export default "__VITE_PUBLIC_ASSET__3a636ff9__"